/*
 * @Author: Teemo Ding
 * @Date: 2021-09-24 09:49:59
 * @LastEditTime: 2022-06-01 18:09:44
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/DestinationAddressLocalisation/setting.tsx
 */

import { Button, Skeleton } from '@/src/components/Antd';
import CommonHeader from '@/src/components/CommonHeader';
import { getAllLanguage } from '@/src/request/common/index';
import {
  getDestinationLanguagesDetail,
  resetDestinationLanguagesDetail,
  saveDestinationLanguagesDetail,
} from '@/src/request/settings/logistics/destinationLanguages';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Form } from 'antd';
import React, { memo, useEffect, useState } from 'react';
//import { useRequest } from 'ahooks';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Singapore from './Singapore';
import SubdivisionTranslation from './SubdivisionTranslation';
import { breadcrumbData } from './config';
import css from './css.module.less';

interface IParams {
  countryCode: string;
}
const permissions = () => {
  const view_destinationaddress_localisation_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory:
          EnumSubCategory.SettingsLogisticsDestinationAddressLocalisation,
        operation: EnumOperation.view_all_logistics_settings_page,
      }),
    ],
  });
  const edit_destinationaddress_localisation_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory:
          EnumSubCategory.SettingsLogisticsDestinationAddressLocalisation,
        operation: EnumOperation.edit_destinationaddress_localisation_setting,
      }),
    ],
  });
  return {
    view_destinationaddress_localisation_setting,
    edit_destinationaddress_localisation_setting,
  };
};
const DestinationSetting = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    view_destinationaddress_localisation_setting,
    edit_destinationaddress_localisation_setting,
  } = permissions();
  const history = useHistory();
  const params = useParams<IParams>();
  const [form] = Form.useForm();
  const [hasModified, setHasModified] = useState<boolean>(false);
  const [allLanguages, setAllLanguages] = useState([]);
  const [loading, setLoading] = useState(true);

  const { countryCode } = params;
  const notEditableCountry = ['CN', 'AT', 'MO', 'HK'];
  const notEditable = notEditableCountry.includes(countryCode);
  useEffect(() => {
    if (view_destinationaddress_localisation_setting) {
      const getDestinationLanguagesDetailReq =
        getDestinationLanguagesDetail(countryCode);
      const getAllLanguageReq = getAllLanguage();

      Promise.all([getAllLanguageReq, getDestinationLanguagesDetailReq]).then(
        (data) => {
          const allLanguages = data[0];
          setAllLanguages(allLanguages);
          const destinationLanguagesDetail = data[1];
          setLoading(false);
          // const aa = [];
          // destinationLanguagesDetail.forEach((item) => {
          //   item.subdivisions.forEach((list) => {
          //     console.log(list);
          //   });
          // });
          // console.log(aa, 'aa');
          form.setFieldsValue({
            supportedLanguage: destinationLanguagesDetail.map(
              (item) => item.locale,
            ),
            subdivisions: destinationLanguagesDetail,
          });
        },
      );
    } else {
      setLoading(false);
    }
  }, []);

  const goBackToList = () => {
    history.push(`/settings/logistics`);
  };

  const onValuesChange = () => {
    setHasModified(true);
  };

  const handleReset = () => {
    resetDestinationLanguagesDetail(countryCode).then((data) => {
      form.setFieldsValue({
        supportedLanguage: data.map((item) => item.locale),
        subdivisions: data,
      });
    });
    // console.log(loadingWarehouseList);
  };

  const onFinish = (values) => {
    console.log(values);
    values.courierAccount = values.courierAccount
      ? { uuid: values.courierAccount }
      : '';
    values.warehouseLocations = values.warehouses;
    values.uuid = countryCode;
    delete values.warehouses;
    saveDestinationLanguagesDetail(values.subdivisions);
  };

  return (
    <Skeleton loading={loading} active>
      <CommonHeader
        breadcrumbData={breadcrumbData({ getI18n })}
        onSaveDisable={
          !hasModified || !edit_destinationaddress_localisation_setting
        }
        {...(!notEditable && { onSubmit: () => form.submit() })}
        {...(!notEditable && { onDiscard: goBackToList })}
        onGoBackClick={goBackToList}
        {...(!notEditable && {
          extendButton: (
            <Button
              danger
              disabled={!edit_destinationaddress_localisation_setting}
              className={css.resetButton}
              onClick={handleReset}
              ghost>
              {getI18n('storeLogistics.destinationAddressLocalisation.reset')}
            </Button>
          ),
        })}
        // onDelete={countryCode ? onDelete : null}
      />
      <div className={css.commonContainer}>
        <Form
          layout={'vertical'}
          form={form}
          className={css.editForm}
          initialValues={{}}
          onFinish={onFinish}
          onValuesChange={onValuesChange}>
          {view_destinationaddress_localisation_setting && (
            <Singapore
              notEditable={notEditable}
              allLanguages={allLanguages}
              form={form}
            />
          )}
          <SubdivisionTranslation notEditable={notEditable} form={form} />
        </Form>
      </div>
    </Skeleton>
  );
};

export default memo(DestinationSetting);
